import React from "react";
import Layout from "../Layout/MainLayout";
import AboutDes from "../components/AboutDes";
function About() {
  return (
    <Layout>
      <AboutDes />
    </Layout>
  );
}

export default About;
